module.exports = __webpack_public_path__ + "img/IND-B-2-II.8b08622c.png";